/* ============ 移动端汉堡菜单 ============ */

function headerResize(){
    if($(window).width()>1200){
        $('header .login_box').unbind('click');
        $('header .login_btn .login_box').unbind('hover')
        $('header .login_box').click(function(e){
            e.stopPropagation()
        })
        $('header .login_btn .login_box').hover(function(){
            $('header .login_btn .login_box ul').show().css({
                'width':300,
                'marginLeft':0
            });
            $('header .toggle').removeClass('active');
            $('.header_box_nav').removeClass('active');
        },function(){
            $('header .login_btn .login_box ul').hide();
        });
    }else{
        // 会员
        $('header .login_box').unbind('click');
        $('header .login_btn .login_box').unbind('hover')
        $('header .login_btn .login_box').unbind('mouseenter')
        $('header .login_btn .login_box').unbind('mouseleave')
        $('header .login_box').click(function(e){
            e.stopPropagation();
            if(String($('header .login_box ul').attr('class')).indexOf('active')<0){
                $(".log_list").slideToggle();
                $('header .toggle').removeClass('active');
                $('header').removeClass('active');
            }else{
            }

            $('header .toggle').removeClass('active')
            $('header').removeClass('active');
        });
    }
}
headerResize()
var windowWidth=$(window).width();
$(window).resize(function(){
    if(windowWidth!=$(window).width()){
        headerResize()
        windowWidth=$(window).width()
    }
});
/* ============ 移动端汉堡菜单 ============ */
var $menuBtn = $('header .toggle');

if ($menuBtn.length) {
    $menuBtn.on('click', function () {
        var isOpen = $menuBtn.hasClass('active');
        $menuBtn.toggleClass('active', !isOpen);
        $('header').toggleClass('active', !isOpen);
        if($(window).width()>=990){
            $(".log_list").hide();
        }else{
            $(".log_list").slideUp();
        }
    });
}

/* ============ 页脚订阅表单 ============ */
$('.footer_subscribe_form').on('submit', function (event) {
    event.preventDefault();

    var $input = $(this).find('.footer_subscribe_input');
    if (!$input.length) {
        return;
    }

    var email = $.trim($input.val());
    if (!email) {
        $input.attr('placeholder', 'Please enter a valid email')
            .val('')
            .focus();
        return;
    }

    $input.val('').attr('placeholder', 'Thanks for subscribing!');
});

/* ============ 返回顶部按钮 ============ */
var $backTop = $('.back_top');

if ($backTop.length) {
    var handleScroll = function () {
        $backTop.toggleClass('active', $(window).scrollTop() > 600);
    };

    $(window).on('scroll', handleScroll);
    handleScroll();

    $backTop.on('click', function () {
        $('html, body').animate({ scrollTop: 0 }, 100);
    });
}

/* ============ 系统识别：下载按钮 Windows / Mac ============ */
// 根据访客操作系统，在 html 上添加 is_mac 类，由 CSS 切换 win/mac 按钮显示。
// $('html').toggleClass('is_mac', /Macintosh|Mac OS X|iPhone|iPad|iPod/i.test(navigator.userAgent));
